import { styled } from '@mui/material/styles';
import { AppBar } from '@mui/material';
import { grey } from '@mui/material/colors';

const drawerWidth = '21rem';
const PREFIX = 'Topbar';

export const Classes = {
	userName: `${PREFIX}-userName`,
	appBar: `${PREFIX}-appBar`,
	menuButton: `${PREFIX}-menuButton`,
	avatar: `${PREFIX}-avatar`,
	toggle: `${PREFIX}-toggle`,
	subtitle: `${PREFIX}-subtitle`
};

export const StyledAppBar = styled(AppBar)(({ theme }) => ({
	// This ensures we respect the notch
	paddingTop: 'env(safe-area-inset-top)',
	// If you want an explicit height, include the safe-area
	// height: `calc(64px + env(safe-area-inset-top))`,

	[`& .${Classes.userName}`]: {
		margin: '0.4rem'
	},

	[`&.${Classes.appBar}`]: {
		position: 'fixed',
		background: theme.palette.mode === 'light' ? 'white' : 'rgb(19, 66, 111)',
		borderBottom: `1px solid ${grey[300]}`,
		boxShadow: 'none',

		[theme.breakpoints.up('md')]: {
			borderBottom: 'none',
			position: 'absolute',
			width: `calc(100% - ${drawerWidth}px)`,
			marginLeft: drawerWidth
		}
	},

	[`& .${Classes.menuButton}`]: {
		marginRight: theme.spacing(2),
		[theme.breakpoints.up('md')]: {
			display: 'none'
		}
	},

	[`& .${Classes.avatar}`]: {
		margin: 10,
		width: 40,
		height: 40,
		border: '1px solid black'
	},

	[`& .${Classes.toggle}`]: {
		checked: theme.palette.mode === 'dark'
	},

	[`& .${Classes.subtitle}`]: {
		fontWeight: 'bold'
	}
}));
